import { Gamepad2, Gift, Lamp, Rocket } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const cats = [
  { name: "Desk accessories", icon: Lamp, bg: "var(--cyan)" },
  { name: "Gaming gear", icon: Gamepad2, bg: "var(--lime)" },
  { name: "Toys", icon: Rocket, bg: "var(--orange)" },
  { name: "Personalised gifts", icon: Gift, bg: "var(--pink)" },
];

export const Welcome = ({ onCategory }) => (
  <section data-testid="welcome-section" className="px-4 sm:px-8 py-16 sm:py-32">
    <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-12 gap-3 sm:gap-6">
      <Reveal className="col-span-2 md:col-span-7 h-full">
        <div className="h-full rounded-[28px] chunk bg-white p-7 sm:p-10 lg:p-12 flex flex-col items-start justify-between gap-8">
          <Eyebrow>Our little corner</Eyebrow>
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
            At Scratchs3dprintz, we turn filament into <span className="font-serif-i font-normal text-[var(--pink)]">fun, colourful</span> and practical creations.
          </h2>
          <p className="text-base sm:text-lg leading-relaxed text-[#3b3550] max-w-2xl">
            There's something for everyone. Browse our ready-made prints or get in touch if you've got an idea you'd love to bring to life. We love making things a little different!
          </p>
        </div>
      </Reveal>
      <Reveal className="col-span-2 md:col-span-5 h-full" delay={0.1}>
        <div className="relative h-full min-h-[240px] sm:min-h-[320px] rounded-[28px] chunk overflow-hidden bg-[var(--ink)] group grain">
          <img src="/images/printer2.jpg" alt="3D printer nozzle mid-print" className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-1000" />
          <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[var(--ink)] to-transparent">
            <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-[var(--yellow)] font-bold">Fresh off the print bed</p>
            <p className="font-display font-extrabold text-2xl text-white mt-1">Every piece printed to order</p>
          </div>
        </div>
      </Reveal>
      {cats.map((c, i) => (
        <Reveal key={c.name} className="col-span-1 md:col-span-6 lg:col-span-3 h-full" delay={0.05 * i}>
          <button data-testid={`category-tile-${c.name.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => onCategory(c.name)}
            className="w-full h-full text-left rounded-[20px] sm:rounded-[24px] chunk-sm sm:chunk press p-4 sm:p-7 flex flex-col-reverse items-start sm:flex-row sm:items-center justify-between gap-3 sm:gap-4" style={{ background: c.bg }}>
            <span className="font-display font-extrabold text-lg sm:text-2xl tracking-tight leading-tight">{c.name}</span>
            <span className="w-10 h-10 sm:w-12 sm:h-12 shrink-0 rounded-full bg-white chunk-sm grid place-items-center"><c.icon className="w-5 h-5" /></span>
          </button>
        </Reveal>
      ))}
    </div>
  </section>
);
